import React from 'react';
import styled from 'styled-components';


export default function DeleteConfirmationModal({ itemName, onCancel, onConfirm }) {
    return (
      <Overlay>
        <Dialog>
          <p>Are you sure you want to delete <strong>{itemName}</strong>?</p>
          <ButtonRow>
            <Button data-variant="cancel" onClick={onCancel}>Cancel</Button>
            <Button data-variant="confirm" onClick={onConfirm}>Confirm</Button>
          </ButtonRow>
        </Dialog>
      </Overlay>
    );
  }
  

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const Dialog = styled.div`
  background: #fff;
  padding: 1.5rem;
  border-radius: 8px;
  width: 320px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
`;

const ButtonRow = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
`;

const Button = styled.button`
  flex: 1;
  margin: 0 0.25rem;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &[data-variant="cancel"] {
    background: #ccc;
  }
  &[data-variant="confirm"] {
    background: #d32f2f;
    color: #fff;
  }
`;
